/**
 *
 * FlashCardLanding
 *
 */

export const FlashCardBookMixin = {
  name: 'FlashCardBookMixin',

  props: {
    p_book: {
      type: Object,
      default: () => ({}),
    },
  },
};
